'use client';

import {
  forwardRef,
  type ForwardRefExoticComponent,
  type RefAttributes,
} from 'react';
import { Box } from '@mui/material';
import type { BoxProps, Theme } from '@mui/material';
import clsx from 'clsx';

import mixinSx from '@watershed/style/mixinSx';

export const INLINE_CODE_CLASSNAME = 'RFInlineCode';

export const inlineCodeSx = {
  fontFamily: (theme: Theme) => theme.typography.fontFamilyMonospace,
  fontSize: '0.85em',
  color: (theme: Theme) => theme.palette.text.secondary,
  border: (theme: Theme) => `1px solid ${theme.palette.divider}`,
  backgroundColor: (theme: Theme) => theme.palette.info.light,
  paddingX: '0.2em',
  paddingY: '0.1em',
  borderRadius: 'min(0.3em, 8px)',
  boxDecorationBreak: 'clone',
};

export type InlineCodeProps = Omit<BoxProps<'code'>, 'component' | 'ref'>;

const InlineCode: ForwardRefExoticComponent<
  InlineCodeProps & RefAttributes<HTMLElement>
> = forwardRef<HTMLElement, InlineCodeProps>(function InlineCode(
  { sx, className, children, ...props },
  ref
) {
  return (
    <Box
      {...props}
      component="code"
      ref={ref}
      className={clsx(INLINE_CODE_CLASSNAME, className)}
      sx={mixinSx(inlineCodeSx, sx)}
    >
      {children}
    </Box>
  );
});

export default InlineCode;
